var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApartmentTypeDetailsBaseComponent } from './../common-theme/index';
var ApartmentTypeDetailsComponent = /** @class */ (function (_super) {
    __extends(ApartmentTypeDetailsComponent, _super);
    function ApartmentTypeDetailsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApartmentTypeDetailsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var title = this.apartmentType.title.toLocaleLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, function (match) { return match.toUpperCase(); });
        this.setTitle(title);
        this.setMetaDescription(title + " - Tip apartament Dream Residence. " + this.apartmentType.description);
    };
    ApartmentTypeDetailsComponent.prototype.compareString = function (a, b) {
        if (a.project.name < b.project.name)
            return -1;
        if (a.project.name > b.project.name)
            return 1;
        return 0;
    };
    return ApartmentTypeDetailsComponent;
}(ApartmentTypeDetailsBaseComponent));
export { ApartmentTypeDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/houses/apartment-type-details.component.ts.pre-build-optimizer.js